import * as amplitude from "@amplitude/analytics-browser";
import { plugin as engagementPlugin } from "@amplitude/engagement-browser";
import { AMPLITUDE_VERSION_NAME } from "@/config/amplitude";
import { apiUrl } from "@/config/app";
import User from "@/models/User";

export function initializeAmplitude(user: User, amplitudeKey?: string) {
  if (amplitudeKey) {
    amplitude.add(engagementPlugin());

    amplitude.init(amplitudeKey, undefined, {
      serverUrl: `${apiUrl.getInstance()}/amplitude/2/httpapi`,
      appVersion: AMPLITUDE_VERSION_NAME || "0.1",
      minIdLength: 1,
      autocapture: {
        frustrationInteractions: true,
        webVitals: true,
      },
    });

    if (user) {
      amplitude.setUserId(String(user.id));
    }

    const initIdentity = new amplitude.Identify();
    initIdentity.set("app_version", AMPLITUDE_VERSION_NAME || "0.1");
    amplitude.identify(initIdentity);
  }

  return amplitude;
}

export default amplitude;
